export default "__VITE_ASSET__DGTY7ayM__"